import {AfterViewInit, Component, DOCUMENT, ElementRef, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-sidebar',
  imports: [MatButtonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements AfterViewInit {
  private readonly document = inject(DOCUMENT);
  private readonly myElement = inject(ElementRef);

  ngAfterViewInit(): void {
    // Ideally this would pick up the height _with_ all the banners,
    // but at AfterViewInit time they're not activated yet
    // so we have to delay to after AfterViewInit.
    globalThis.setTimeout(() => {
      const headerElement = this.document.querySelector('header.app-header');
      if (!headerElement) return;
      (this.myElement.nativeElement as HTMLElement).style.setProperty(
        '--rde-header-height',
        headerElement.scrollHeight + 'px',
      );
    }, 0);
  }
}
